module.exports = __webpack_public_path__ + "img/drawing.be5030ca.webp";